import React from 'react';
import { TaskHistoryEntry } from '../types';
import { formatRelativeTime } from '../constants';

interface TaskTimelineProps {
  items: TaskHistoryEntry[];
}

export const TaskTimeline: React.FC<TaskTimelineProps> = ({ items }) => {
  if (items.length === 0) {
    return <p className="task-details-modal__history-empty">No history yet.</p>;
  }

  return (
    <ul className="task-details-modal__timeline">
      {items.map((item) => (
        <li key={item.id} className="task-details-modal__timeline-item">
          <span className="task-details-modal__timeline-dot" aria-hidden="true" />
          <div className="task-details-modal__timeline-copy">
            <p>
              <strong>{item.author}</strong>
              {item.parts.map((part, index) => {
                if (part.type === 'text') {
                  return <span key={index}>{part.value}</span>;
                }

                return (
                  <span
                    key={index}
                    className={`task-details-modal__timeline-highlight task-details-modal__timeline-highlight--${part.type}`}
                  >
                    {part.value}
                  </span>
                );
              })}
            </p>
            <time>{formatRelativeTime(item.createdAt)}</time>
          </div>
        </li>
      ))}
    </ul>
  );
};
